import React, {  Fragment } from 'react';
import PropTypes from 'prop-types';

import RightIcon from '@material-ui/icons/KeyboardArrowRight';
import LeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import { isMobile } from "../../utils/device";

const pdfjs = await import('pdfjs-dist/build/pdf');


class PdfComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageCount: null,
            pageNum:1

        };

        this.canvasRef = React.createRef();
       
        this.scale =  isMobile?0.5:1.5;
        this.pdf = null;
        this.pageRendering = false;
        this.pageNum = 1;
        this.pageNumPending = null;
        this.pageCount = null;

    }
    async componentDidMount() {
       
        const loadingTask = pdfjs.getDocument(this.props.src);
        this.pdf = await loadingTask.promise;
        this.setState({pageCount:this.pdf.numPages});
        await this.renderPage(this.state.pageNum);
    }

    queueRenderPage(num) {
        if (this.pageRendering) {
            this.pageNumPending = num;
        } else {
            this.renderPage(num).then(r => {});
        }
    }

    async renderPage(num) {
        this.pageRendering = true;
        const page = await this.pdf.getPage(num);
        const viewport = page.getViewport({ scale: this.scale });

        // Prepare canvas using PDF page dimensions
        const canvas = this.canvasRef.current;

        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        // this does render
        const renderTask = page.render(renderContext);
        // this waits for it
        await renderTask.promise.then(()=> {
            this.pageRendering = false;
            if (this.pageNumPending !== null) {
                // New page rendering is pending
                this.renderPage(this.pageNumPending);
                this.pageNumPending = null;
            }
        });
        this.setState({pageNum:num});
        this.pageNum = num;
    }

    onPrevPage() {
        if (this.pageNum <= 1) {
            return;
        }
        this.pageNum--;
        this.queueRenderPage(this.pageNum);
    }

    onNextPage() {
        if (this.pageNum >= this.pdf.numPages) {
            return;
        }
        this.pageNum++;
        this.queueRenderPage(this.pageNum);
    }

    onHandleDirectionsButton(direction) {
        if (direction === "left") {
          this.onPrevPage();
    
        } else {
          this.onNextPage();
        }
      }

    renderContentNextButton = (direction) => {
        var height = null;
        var Icon = RightIcon;
        if (direction === "left") {
          Icon = LeftIcon
        }
        return (
          <div onClick={() => { this.onHandleDirectionsButton(direction) }} style={{ height: (height ? height * 0.9 : 45), width: (height ? height * 0.9 : 45), marginRight: 3 }} className={"roundedMagnifier"}>
            <Icon style={{ color: "white", width: (height ? (height / 45) * 28 : 28), height: (height ? (height / 45) * 28 : 28) }} />
          </div>
        )
    
      }

    render() {
        return (
            <Fragment>
                 <div style={{justifyContent:"space-between",display:"flex"}}>
                    {this.renderContentNextButton("left")}
                    <div>
                    Seite {this.state.pageNum} / {this.state.pageCount}
                </div>
                    {this.renderContentNextButton("right")}
                </div>
                <canvas
                    ref={this.canvasRef}
                    width={window.innerWidth}
                    height={window.innerHeight}
                    style={{marginLeft:"auto", marginRight:"auto"}}
                />
               
               
            </Fragment>

        )
    }


}

PdfComponent.propTypes = {
    src: PropTypes.string
};

PdfComponent.defaultProps = {
};

export default PdfComponent;